import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  getAMLSTMCommonTransactionHistory,
  downloadAMLSTMCommonTransactionHistory,
  getAMLSTMCommonTransactionTriggeredTypologies,
  getAMLSTMCommonTransactionTriggeredVariants,
  getAMLSTMCommonTransactionTypesFilter
} from '../../../redux/actions/tmCommon';
import { getAMLSCommonAlertPartyIdentity } from '../../../redux/actions/common';
import TransactionDetails from './TransactionDetails';

const mapStateToProps = (state, ownProps) => {
  const { alertPartyIdentity = {}, alertDetails = {} } = state.amlsCommon;
  const {
    transactionHistory = {},
    transactionHistoryDownloaded = {},
    transactionTriggeredTypologies = {},
    transactionTriggeredVariants,
    transactionTypesFilter = {}
  } = state.amlsTMCommon;
  const { data: transactionHistoryData, error, isLoading } = transactionHistory;
  const { data: customerInfo, isLoading: isCustomerInfoLoading } =
    alertPartyIdentity;
  const { data: primaryPartyKeyInfo, isLoading: isAlertDetailsLoading } =
    alertDetails;
  const { data: typologies } = transactionTriggeredTypologies;
  const { primaryPartyKey = '' } = primaryPartyKeyInfo || {};
  const { partyKey = '' } = customerInfo || {};
  const { isLoading: isTxnHistoryDownloading } = transactionHistoryDownloaded;
  const { data: transactionTypesFilterData } = transactionTypesFilter;

  return {
    transactionHistory: transactionHistoryData,
    error,
    isLoading,
    isTxnHistoryDownloading,
    isCustomerInfoLoading,
    // FIN-11398 — customer-scoped mounts (FRAML customer-detail) pass an explicit
    // customerId own-prop; it wins over the alert-derived party key. Alert-detail
    // mounts never pass it, so their behaviour is unchanged.
    customerId: ownProps.customerId || primaryPartyKey || partyKey,
    typologies,
    alertDetails,
    isAlertDetailsLoading,
    transactionTriggeredVariants,
    transactionTypesFilterData,
    // Fallback moduleId from the user's current product login; used only when the
    // parent component does not pass an explicit `moduleId` prop (see TransactionDetails).
    loginModuleId: state.authentication?.currentProductLogin?.moduleId
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    apiActions: bindActionCreators(
      {
        getAMLSCommonAlertPartyIdentity,
        getAMLSTMCommonTransactionHistory,
        getAMLSTMCommonTransactionTriggeredTypologies,
        getAMLSTMCommonTransactionTriggeredVariants,
        downloadAMLSTMCommonTransactionHistory,
        getAMLSTMCommonTransactionTypesFilter
      },
      dispatch
    )
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TransactionDetails);
